import { Component } from '@angular/core';
import { StoreService } from '@app/shared/services/store.service';

@Component({
    selector: 'app-block-banner',
    templateUrl: './block-banner.component.html',
    styleUrls: ['./block-banner.component.scss']
})
export class BlockBannerComponent {

    image_full = 'assets/images/banners/banner-1.jpg';
    image_mobile = 'assets/images/banners/banner-1-mobile.jpg';
    title = '';
    text = '';
    banner_center2 = ''

    constructor(
        public storeService: StoreService
    ) {
        try {
            setTimeout(() => {
                // Get store data and check if it exists before parsing
                const storeData = localStorage.getItem('store');
                if (storeData) {
                    const slides = JSON.parse(storeData).banners as [];
                    console.log(slides);

                    // Find the banner with the tag 'banner_center'
                    const centerBanner = slides.filter(x => x['tag'] === 'banner_center');

                    // Check if the banner was found before trying to access its properties
                    if (centerBanner.length > 0) {
                        this.image_full = centerBanner[0]['image_classic'];
                        this.title = centerBanner[0]['title'];
                        this.text = centerBanner[0]['text'];
                    }
                }
            }, 1000);
        } catch (error) {
            console.log(error);
        }
    }
}
